function initializeSetup() {
    const config = window.pawPrintConfig || {};
    const offerType = window.determineOfferType ? window.determineOfferType() : window.offerType;
    const OFFER_TYPES = window.OFFER_TYPES || {};

    const urlParams = new URLSearchParams(window.location.search);
    const urlReferralCode = urlParams.get('r');
    const urlCampaign = urlParams.get('utm_campaign');
    const submissionIdentifier = urlParams.get('submission_identifier');
    const encodedDN = urlParams.get('dn') || urlParams.get('d');
    const encodedSiu = urlParams.get('siu');
    const genericId = urlParams.get('id'); // Only used for keepsake portrait offers right now

    var urlDogId;
    var urlAssignmentOfferId;

    if (urlReferralCode) {
        if (urlReferralCode.includes('|')) {
            urlDogId = urlReferralCode.split('|')[0];

            const offerId = urlReferralCode.split('|')[1];
            if (offerId) {
                if (!/^so_/i.test(offerId)) {
                    urlAssignmentOfferId = offerId;
                    localStorage.setItem('url_assignment_offer_id', urlAssignmentOfferId);
                } else {
                    const soPart = window.getSubmissionOfferForCurrentPage();

                    if (soPart) {
                        localStorage.setItem(`so_cache.${location.pathname}`, JSON.stringify({
                            soPart,
                            createdAt: Date.now()
                        }));
                    }
                }
            }
        } else {
            urlDogId = urlReferralCode;
        }
    }

    const isNewDogID = urlReferralCode && localStorage.getItem('dog_id') !== urlReferralCode;
    const dogId = urlDogId || localStorage.getItem('dog_id') || getDogIDCookie();
    const assignmentOfferId = urlAssignmentOfferId || localStorage.getItem('url_assignment_offer_id');
    const submissionOfferId = window.getSubmissionOfferForCurrentPage();
    const campaign = urlCampaign || localStorage.getItem('campaign') || getCampaignCookie();

    // Derive the image URL from the submissionCache (keyed by dogId) first.
    // submission-cache.js stores the full submission response (the same shape returned by fetchSubmissionRequest().json()),
    // which is why we look for `submission.data.image_url`. Fall back to the legacy `image_url` localStorage key if nothing found.
    var imageUrl = (function () {
        if (encodedSiu) {
            const siu = atob(encodedSiu);
            localStorage.setItem('image_url', siu);
            return siu;
        }

        try {
            const stored = JSON.parse(localStorage.getItem('submissionCache') || '{}');
            const submission = dogId && stored ? stored[dogId] : null;

            if (submission && submission.data && submission.data.image_url) {
                console.log('Found image URL in submissionCache for dog ID', dogId);
                return submission.data.image_url;
            }
        } catch (e) {
            // ignore parse errors and fall back
        }

        return null;
    })();

    var dn = null;

    if (encodedDN) {
        try {
            dn = atob(encodedDN);

            localStorage.setItem('dn', dn);
        } catch (e) {
            // ignore decoding errors and leave dn as null
        }
    } else if (!isNewDogID) {
        dn = localStorage.getItem('dn');
    }

    return {
        config,
        offerType,
        OFFER_TYPES,
        urlCampaign,
        isNewDogID,
        dogId,
        assignmentOfferId,
        submissionIdentifier,
        submissionOfferId,
        campaign,
        dn,
        imageUrl,
        genericId,
    }
}

window.initializeSetup = initializeSetup;
